import { environment } from '@env';

export const getImageProxyUrl = (url: string): string => {
  const imgId = getImgId(url);
  if (!imgId) {
    return url;
  }
  return buildImageUrl(imgId);
};

export const buildImageUrl = (imageId: string): string => {
  const backendUrl = environment.api.url;
  return `${backendUrl}/hgs-new/proxy-image?id=${imageId}&type=image`;
};

export const getImgId = (url: string): string | undefined => {
  const urlObj = new URL(url);
  return urlObj.searchParams.get('imageId') ?? undefined;
};

export const splitServiceTitle = (title: string | undefined) => {
  if (!title) return undefined;
  const name = title.replace(/\(.*\)/g, '').trim();

  // '(?<=\()' and '(?=\))' are lookbehind and lookahead assertions
  // that match the content inside parentheses without including the parentheses in the result
  const result = title.match(/(?<=\().*?(?=\))/g) ?? [];
  return { name, interval: result[0]?.replace(/\s*\/\s*/g, ' / ') };
};
